import { connect } from 'react-redux';
import UsersDropdown from '../components/users-dropdown';
import { fetchUsers, clearUsersData, fetchRestrictedUsers } from './users-dropdown-actions';

const mapStateToProps = (state) => {
  const { users: { users, loading } } = state;

  return {
    users,
    loading,
  };
};

const mapDispatchToProps = {
  fetchUsers,
  fetchRestrictedUsers,
  clearUsersData,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersDropdown);
